import {state, mutations} from './errorMutation.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/errorModules/errorModule.js